import { generateUID } from "../utils/generateUID";
import {
  InProgress,
  CheckmarkFilled,
  ErrorFilled,
  InProgressError,
} from "@carbon/icons-react";

export const requestsMapper = (list, t) => {
  if (!Array.isArray(list) || list.length === 0) {
    return { headers: [], rows: [] };
  }

  const sortedList = [...list].sort(
    (a, b) => new Date(b.created) - new Date(a.created)
  );

  let headers = Object.keys(sortedList[0])
    .filter((key) => key !== "agentid" && key !== "farmid")
    .map((key) => ({
      header: `admin.requestsList.table.${key}`,
      key: key,
    }));

  return {
    headers,
    rows: sortedList.map((item) => {
      const row = {};

      row.id = String(item.code ?? generateUID());

      Object.keys(item).forEach((key) => {
        if (item[key] == null) {
          row[key] = "";
        } else if (key === "created") {
          const date = new Date(item[key]);

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          const hh = String(date.getHours()).padStart(2, "0");
          const min = String(date.getMinutes()).padStart(2, "0");

          row[key] = `${yyyy}-${mm}-${dd} ${hh}:${min}`;
        } else if (key === "state") {
          switch (item[key]) {
            case "NEW":
              row[key] = (
                <span className="indicator_cell">
                  <InProgress fill="blue" />{" "}
                  {t("admin.requestsList.table.statusValues.new")}
                </span>
              );
              break;
            case "APPROVED":
              row[key] = (
                <span className="indicator_cell">
                  <CheckmarkFilled fill="green" />{" "}
                  {t("admin.requestsList.table.statusValues.approved")}
                </span>
              );
              break;
            case "CANCELED":
              row[key] = (
                <span className="indicator_cell">
                  <ErrorFilled fill="red" />{" "}
                  {t("admin.requestsList.table.statusValues.declined")}
                </span>
              );
              break;
            case "CANCELEDBYTIMEOUT":
              row[key] = (
                <span className="indicator_cell">
                  <InProgressError fill="salmon" />{" "}
                  {t("admin.requestsList.table.statusValues.expired")}
                </span>
              );
              break;
            default:
              row[key] = String(item[key]);
          }
        } else row[key] = item[key];
      });

      return row;
    }),
  };
};
